var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19775 7.4784C5.19775 7.10867 5.34163 6.75409 5.59773 6.49266C5.85383 6.23122 6.20117 6.08435 6.56335 6.08435H22.9505C23.3127 6.08435 23.66 6.23122 23.9161 6.49266C24.1722 6.75409 24.3161 7.10867 24.3161 7.4784C24.3161 7.84812 24.1722 8.2027 23.9161 8.46413C23.66 8.72557 23.3127 8.87244 22.9505 8.87244H6.56335C6.20117 8.87244 5.85383 8.72557 5.59773 8.46413C5.34163 8.2027 5.19775 7.84812 5.19775 7.4784ZM5.19775 14.4486C5.19775 14.0789 5.34163 13.7243 5.59773 13.4629C5.85383 13.2014 6.20117 13.0546 6.56335 13.0546H22.9505C23.3127 13.0546 23.66 13.2014 23.9161 13.4629C24.1722 13.7243 24.3161 14.0789 24.3161 14.4486C24.3161 14.8183 24.1722 15.1729 23.9161 15.4344C23.66 15.6958 23.3127 15.8427 22.9505 15.8427H6.56335C6.20117 15.8427 5.85383 15.6958 5.59773 15.4344C5.34163 15.1729 5.19775 14.8183 5.19775 14.4486ZM5.19775 21.4188C5.19775 21.0491 5.34163 20.6945 5.59773 20.4331C5.85383 20.1717 6.20117 20.0248 6.56335 20.0248H22.9505C23.3127 20.0248 23.66 20.1717 23.9161 20.4331C24.1722 20.6945 24.3161 21.0491 24.3161 21.4188C24.3161 21.7886 24.1722 22.1431 23.9161 22.4046C23.66 22.666 23.3127 22.8129 22.9505 22.8129H6.56335C6.20117 22.8129 5.85383 22.666 5.59773 22.4046C5.34163 22.1431 5.19775 21.7886 5.19775 21.4188Z",
    fill: "#4BB869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e6ce34130c7ca3ef1b3d1f49f352bb8d.svg";
export { ForwardRef as ReactComponent };